import React, { useEffect, useState } from "react";
import { FaEdit, FaTrashAlt } from "react-icons/fa";

import FiltroInformacion from "./FiltroInformacion";
import CrearInformacion from "./CrearInformacion";
import EditarInformacion from "./EditarInformacion";
import VerInformacion from "./VerInformacion";
import EliminarInformacion from "./EliminarInformacion";
import ListHeader from "../../../components/listing/ListHeader";
import ListFooter from "../../../components/listing/ListFooter";
// IMPORTANTE: Importamos DynamicTable
import DynamicTable from "../../../components/listing/DynamicTable";

import apiRoutes from "../../../api/apiRoutes";
import { appFetchJson } from "../../../utils/http";

export default function ListarInformacion() {
  // === PAGINACIÓN REAL DEL BACK ===
  const [porPagina, setPorPagina] = useState(10);
  const [pagina, setPagina] = useState(1);

  const [totalBackend, setTotalBackend] = useState(0);

  // === DATA ===
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // === UI STATE ===
  const [mostrarCrear, setMostrarCrear] = useState(false);
  const [mostrarEditar, setMostrarEditar] = useState(false);
  const [mostrarVer, setMostrarVer] = useState(false);
  const [mostrarEliminar, setMostrarEliminar] = useState(false);
  const [mostrarFiltros, setMostrarFiltros] = useState(false);

  const [itemSel, setItemSel] = useState(null);
  const [reloadKey, setReloadKey] = useState(0);

  // ===== CLIENTES (precarga para CrearInformacion) =====
  const [clientes, setClientes] = useState([]);
  const [clientesLoading, setClientesLoading] = useState(false);

  // === FILTROS ===
 const [filtros, setFiltros] = useState({
  fecha: "",
  informacion: "",
  clienteObj: null,    // objeto completo de ClienteAutocomplete
  eessObj: null,       // objeto completo de EessAutocomplete
});

  // ================================
  //   CARGAR DATOS DESDE EL BACKEND
  // ================================
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);

      try {
        const url = apiRoutes.informacion.listUrl({
          page: pagina - 1,
          size: porPagina,
          q: filtros.informacion || "",
          fecha: filtros.fecha || "", 
          clienteId: filtros.clienteObj?.id,
          eessId: filtros.eessObj?.id,
        });

        const res = await appFetchJson(url);

        const items = Array.isArray(res?.items) ? res.items : [];
        setData(items);

        // Paginación Real
        const total = res?.totalElements ?? res?.total ?? items.length;
        setTotalBackend(total);
      } catch (e) {
        console.error("Error cargando información:", e);
        setError("Error al cargar la información.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [pagina, porPagina, filtros, reloadKey]);

  useEffect(() => {
    const fetchClientes = async () => {
      setClientesLoading(true);
      try {
        const data = await appFetchJson(apiRoutes.clientes.combo);
        const list = (data ?? []).map((c) => ({
          id: c.id,
          codigo: c.codigo,
          nombre: c.nombre,
        }));
        setClientes(list);
      } catch (e) {
        console.error("Error precargando clientes:", e);
      } finally {
        setClientesLoading(false);
      }
    };

    fetchClientes();
  }, []);

// ====================================================================
  // DEFINICIÓN DE COLUMNAS (TOTAL 100%)
  // ====================================================================
  const columns = [
    // 1. FECHA (12%)
    { 
      header: "Fecha", 
      accessor: "fecha",
      type: "center", 
      width: "12%", 
    },
    // 2. INFORMACIÓN (25%) - Ajustado para mejor balance
    { 
      header: "Información", 
      accessor: "descripcion",
      type: "text", 
      width: "25%", 
      cellClass: "whitespace-normal break-words leading-tight font-medium text-gray-800"
    },
    // 3. CLIENTE (30%) - Reducido para eliminar el espacio vacío excesivo
    { 
      header: "Cliente", 
      accessor: "clienteNombre",
      type: "text", 
      width: "30%", 
      cellClass: "whitespace-normal break-words leading-tight text-gray-600"
    },
    // 4. EE.SS. (25%) - Aumentado para absorber espacio y mostrar nombres largos
    { 
      header: "EE.SS.", 
      accessor: "eessNombre",
      type: "text", 
      width: "25%",
      cellClass: "whitespace-normal break-words leading-tight text-gray-600"
    },
    // 5. ACCIÓN (8%)
    {
      header: "Acción",
      type: "action", 
      width: "8%",
      render: (it) => (
        <div className="flex justify-center items-center gap-2">
          <button
            className="text-gray-500 hover:text-blue-600 p-1"
            title="Editar"
            onClick={() => {
              setItemSel(it);
              setMostrarEditar(true);
            }}
          >
            <FaEdit />
          </button>

          <button
            className="text-gray-500 hover:text-red-600 p-1"
            title="Eliminar"
            onClick={() => {
              setItemSel(it);
              setMostrarEliminar(true);
            }}
          >
            <FaTrashAlt />
          </button>
        </div>
      )
    }
  ];

  // ================================
  //   RENDER
  // ================================
  return (
    <div className="page">

      <ListHeader
        title="Información"
        onFilterClick={() => setMostrarFiltros(true)}
        filters={filtros}
   onClearFilters={() => {
  setFiltros({
    fecha: "",
    informacion: "",
    clienteObj: null,
    eessObj: null,
  });
  setPagina(1);
}}
        showAdd
        addLabel="Agregar"
        onAddClick={() => setMostrarCrear(true)}
        pageSize={porPagina}
        onPageSizeChange={(size) => {
          setPorPagina(size);
          setPagina(1);
        }}
      />

      {/* Loading / Error */}
      {loading && (
        <div className="mt-2 text-sm text-center text-gray-600">Cargando datos...</div>
      )}
      {error && <div className="mt-2 text-sm text-red-600">{error}</div>}

      {/* Drawer filtros */}
      {mostrarFiltros && (
        <FiltroInformacion
          initialFilters={filtros}
    onSubmit={(nuevosFiltros) => {
  setFiltros({
    fecha: nuevosFiltros.fecha || "",
    informacion: nuevosFiltros.informacion || "",
    clienteObj: nuevosFiltros.clienteObj || null,
    eessObj: nuevosFiltros.eessObj || null,
  });
  setMostrarFiltros(false);
  setPagina(1);
}}
          onClose={() => setMostrarFiltros(false)}
        />
      )}

      {/* TABLA DINÁMICA */}
      {!loading && (
        <DynamicTable 
          size="M" // 5 columnas -> Breakpoint 1024px
          data={data}
          columns={columns}
        />
      )}

      <ListFooter
        page={pagina}
        pageSize={porPagina}
        total={totalBackend}
        onPageChange={(p) => setPagina(p)}
      />

      {/* MODALES */}
      {mostrarCrear && (
        <CrearInformacion
          clientes={clientes}
          clientesLoading={clientesLoading}
          onClose={() => setMostrarCrear(false)}
          onCreated={() => {
            setReloadKey((k) => k + 1);
            setMostrarCrear(false);
          }}
        />
      )}

      {mostrarVer && itemSel && (
        <VerInformacion item={itemSel} onClose={() => setMostrarVer(false)} />
      )}

      {mostrarEditar && itemSel && (
        <EditarInformacion
          data={itemSel}
          onClose={() => setMostrarEditar(false)}
          onUpdated={() => setReloadKey((k) => k + 1)}
        />
      )}

      {mostrarEliminar && itemSel && (
        <div
          className="modal-backdrop"
          onClick={() => setMostrarEliminar(false)}
        >
          <div
            className="modal-panel-lg no-x"
            onClick={(e) => e.stopPropagation()}
          >
            <EliminarInformacion
              registro={itemSel}
              onClose={() => setMostrarEliminar(false)}
              onDeleted={() => {
                setReloadKey((k) => k + 1); // refrescar la tabla
                setMostrarEliminar(false);
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
}